import { settings } from '@alme/ui-web/settings/settings-util';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import * as Actions from './actions/actions';
import {waitForIvaFunction} from '../lib-alight-library/lib-alight-library'

export default class SessionIdOverrideProcessor {

    _settings: typeof settings;
    _store: Store<AlmeState> | undefined;

    constructor(passedSettings: typeof settings)
    {
        this._settings = passedSettings || settings;
    }

    initialize(store: Store<AlmeState>)
    {
        this._store = store;
    }
    
    getPromise(): Promise<any> {
        return this.updateSessionId();
    }

    updateSessionId(): Promise<any> {
        waitForIvaFunction().then((result) =>{
        if(this._store) {
            if (window.enableIVAasService) {
                const initData = window.enableIVAasService();
                const platformId = initData?.platformId;

                if (platformId?.toLowerCase() === 'hrx'){
                    if(initData && initData.personId != null && initData.personId != undefined) {
                        const { Base, isActiveSession, sessionId } = this._settings.stateLocations.Conversation;
                        
                        const state = this._store.getState();

                        const isActive = !!state[Base][isActiveSession];

                        const id = initData.personId;

                        this._store.dispatch(Actions.setSessionId(
                            id,
                            sessionId,
                            isActiveSession,
                            isActive
                        ));
                    }
                }
            }

           
        }
        
        return Promise.resolve();
    });
    return Promise.resolve();
    }
}


// WEBPACK FOOTER //
// ./modules/session-id-override-processor/session-id-override-processor.ts